module.exports = __webpack_public_path__ + "img/fin.cb43f327.svg";